import RsvpsDuplicatesExtendedListViewCtrl from '../../../../../store/rsvps/controllers/duplicates-extended-list-view';

angular
    .module('festzelt-os.guestlists')
    .controller('RsvpsDuplicatesExtendedListViewCtrl', [
        '$injector',
        '$scope',
        ($injector, $scope) => new RsvpsDuplicatesExtendedListViewCtrl($injector, $scope)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/rsvps/store/duplicates-extended-listview.js